import { hideElement } from "../utils/dom";

export default class BreadcrumbComponent extends HTMLElement {

    #step = 0;
    #title = "";

    constructor() {
        super();
    }

    render() {
        this.innerHTML = `
        <div class="steps" aria-label="breadcrumb-steps">
        ${this.#step}
        </div>
        <div class="title" aria-label="breadcrumb-title">
        ${this.#title}
        </div>
    `;
    }

    update(step, maxStep, title) {
        this.#step = `0${step} / 0${maxStep}`;
        this.#title = title;
        this.render();
    }

    hide() {
        hideElement(this, true);
        return this;
    }

}